import React, { Component } from 'react';
import { connect } from 'react-redux';
import clone from 'clone';
import { Link } from 'react-router-dom';
import { Layout } from 'antd';
import Scrollbars from '../../components/utility/customScrollBar.js';
import Menu from '../../components/uielements/menu';
import IntlMessages from '../../components/utility/intlMessages';
import SidebarWrapper from './sidebar.style';
import appActions from '../../redux/app/actions';
import Logo from '../../components/utility/logo';

const SubMenu = Menu.SubMenu;
// const MenuItemGroup = Menu.ItemGroup;
const { Sider } = Layout;

const {
  toggleOpenDrawer,
  changeOpenKeys,
  changeCurrent,
  toggleCollapsed,
} = appActions;
const stripTrailingSlash = str => {
  if (str.substr(-1) === '/') {
    return str.substr(0, str.length - 1);
  }
  return str;
};
class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.onOpenChange = this.onOpenChange.bind(this);
  }
  handleClick(e) {
    this.props.changeCurrent([e.key]);
    if (this.props.app.view === 'MobileView') {
      setTimeout(() => {
        this.props.toggleCollapsed();
        this.props.toggleOpenDrawer();
      }, 100);
    }
  }
  onOpenChange(newOpenKeys) {
    const { app, changeOpenKeys } = this.props;
    const latestOpenKey = newOpenKeys.find(
      key => !(app.openKeys.indexOf(key) > -1)
    );
    const latestCloseKey = app.openKeys.find(
      key => !(newOpenKeys.indexOf(key) > -1)
    );
    let nextOpenKeys = [];
    if (latestOpenKey) {
      nextOpenKeys = this.getAncestorKeys(latestOpenKey).concat(latestOpenKey);
    }
    if (latestCloseKey) {
      nextOpenKeys = this.getAncestorKeys(latestCloseKey);
    }
    changeOpenKeys(nextOpenKeys);
  }
  getAncestorKeys = key => {
    const map = {
      sub3: ['sub2'],
    };
    return map[key] || [];
  };

  render() {
    // const { url, app, toggleOpenDrawer, bgcolor } = this.props;
    const { app, toggleOpenDrawer, customizedTheme } = this.props;
    const url = stripTrailingSlash(this.props.url);
    const collapsed = clone(app.collapsed) && !clone(app.openDrawer);
    const { openDrawer } = app;
    const mode = collapsed === true ? 'vertical' : 'inline';
    const onMouseEnter = event => {
      if (openDrawer === false) {
        toggleOpenDrawer();
      }
      return;
    };
    const onMouseLeave = () => {
      if (openDrawer === true) {
        toggleOpenDrawer();
      }
      return;
    };
    const scrollheight = app.height;
    const styling = {
      backgroundColor: customizedTheme.backgroundColor,
    };
    const submenuStyle = {
      backgroundColor: 'rgba(0,0,0,0.3)',
      color: customizedTheme.textColor,
    };
    const submenuColor = {
      color: customizedTheme.textColor,
    };
    return (
      <SidebarWrapper>
        <Sider
          trigger={null}
          collapsible={true}
          collapsed={collapsed}
          width="240"
          className="isomorphicSidebar"
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          style={styling}
        >
          <Logo collapsed={collapsed} />
          <Scrollbars style={{ height: scrollheight - 70 }}>
            <Menu
              onClick={this.handleClick}
              theme="dark"
              mode={mode}
              openKeys={collapsed ? [] : app.openKeys}
              selectedKeys={app.current}
              onOpenChange={this.onOpenChange}
              className="isoDashboardMenu"
            >

            <Menu.Item key="Campaign">
                <Link to={`${url}/campaign/`}>
                  <span className="isoMenuHolder" style={submenuColor}>
                    <i className="ion-android-mail" />
                    <span className="nav-text">
                      <IntlMessages id="sidebar.campaign" />
                    </span>
                  </span>
                </Link>
            </Menu.Item>
                {/* <Menu.Item key="Events">
                    <Link to={`${url}/events/`}>
                  <span className="isoMenuHolder" style={submenuColor}>
                    <i className="ion-android-mail"/>
                    <span className="nav-text">
                      <IntlMessages id="sidebar.events"/>
                    </span>
                  </span>
                    </Link>
                </Menu.Item> */}
                <Menu.Item key="Scenarios">
                    <Link to={`${url}/scenarios/`}>
                  <span className="isoMenuHolder" style={submenuColor}>
                    <i className="ion-android-mail"/>
                    <span className="nav-text">
                      <IntlMessages id="sidebar.scenarios"/>
                    </span>
                  </span>
                    </Link>
                </Menu.Item>
            {/* <Menu.Item key="media">
                <Link to={`${url}/media/`}>
                  <span className="isoMenuHolder" style={submenuColor}>
                    <i className="ion-android-mail" />
                    <span className="nav-text">
                      <IntlMessages id="sidebar.media" />
                    </span>
                  </span>
                </Link>
            </Menu.Item> */}


              <SubMenu
                key="settings"
                title={
                  <span className="isoMenuHolder" style={submenuColor}>
                    <i className="ion-bag" />
                    <span className="nav-text">
                      <IntlMessages id="sidebar.settings" />
                    </span>
                  </span>
                }
              >
                {/* <Menu.Item style={submenuStyle} key="country">
                  <Link style={submenuColor} to={`${url}/country`}>
                    <IntlMessages id="sidebar.country" />
                  </Link>
                </Menu.Item> */}
                <Menu.Item style={submenuStyle} key="city">
                  <Link style={submenuColor} to={`${url}/city`}>
                    <IntlMessages id="sidebar.city" />
                  </Link>
                </Menu.Item>
                  {/* <Menu.Item style={submenuStyle} key="category">
                      <Link style={submenuColor} to={`${url}/category`}>
                          <IntlMessages id="sidebar.category"/>
                      </Link>
                  </Menu.Item> */}
                <Menu.Item style={submenuStyle} key="location">
                  <Link style={submenuColor} to={`${url}/location`}>
                    <IntlMessages id="sidebar.location" />
                  </Link>
                </Menu.Item>
                {/* <Menu.Item style={submenuStyle} key="template">
                  <Link style={submenuColor} to={`${url}/template`}>
                    <IntlMessages id="sidebar.template" />
                  </Link>
                </Menu.Item> */}
                {/* <Menu.Item style={submenuStyle} key="container">
                  <Link style={submenuColor} to={`${url}/container`}>
                    <IntlMessages id="sidebar.container" />
                  </Link>
                </Menu.Item> */}

                {/* <Menu.Item style={submenuStyle} key="interval">
                  <Link style={submenuColor} to={`${url}/interval`}>
                    <IntlMessages id="sidebar.interval" />
                  </Link>
                </Menu.Item> */}
                
                <Menu.Item style={submenuStyle} key="device">
                  <Link style={submenuColor} to={`${url}/device`}>
                    <IntlMessages id="sidebar.device" />
                  </Link>
                </Menu.Item>
                {/* <Menu.Item style={submenuStyle} key="advertiser">
                  <Link style={submenuColor} to={`${url}/advertiser`}>
                    <IntlMessages id="sidebar.advertiser" />
                  </Link>
                </Menu.Item> */}

              </SubMenu>

            </Menu>
          </Scrollbars>
        </Sider>
      </SidebarWrapper>
    );
  }
}

export default connect(
  state => ({
    app: state.App.toJS(),
    customizedTheme: state.ThemeSwitcher.toJS().sidebarTheme,
  }),
  { toggleOpenDrawer, changeOpenKeys, changeCurrent, toggleCollapsed }
)(Sidebar);



// WEBPACK FOOTER //
// ./src/containers/Sidebar/Sidebar.js